// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/view/settings/Menu11/Item.css
// module id = 2029
// module chunks = 0